<template>
  <div class="send-email-box">
    <span style="font-weight: bold;">
      发送邮件至发起人：{{ userName }}
    </span>
    <div class="input_box">
      <span class="lable">*</span>
      <Input class="ref_input" v-model="inputValue" type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入SAP或POS不能确认的原因" />
    </div>
    附件：
    <input ref="fileInput" type="file" @change="fileChange" />
    <button class="cancel-btn" @click="uploadFile" style="">确认上传</button>

    <div class="pop-btn">
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error" class="sav-btn" @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from "@/assets/js/ChineseDictionary";
export default {
  name: "SendEmail",
  inject: ["moduleComponentName", "instanceRouteQuery", "instanceRoute"],
  data() {
    return {
      fileName: "",
      spinShow: false,
      selectedFile: null,
      userId: null,
      userName: "",
      fileUrl: "",
      inputValue: "",
      tableName: "", // 主表表名
      tableId: "", // 主表ID
      itemId: "", // 子表ID
    };
  },
  created() {
    this.chineseName = ChineseDictionary;
    const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.tableId = tableId;
    this.itemId = itemId;
    this.getUserName();
  },
  activated() { },
  destroyed() { },
  methods: {

    fileChange(event) {
      this.spinShow = true;
      this.selectedFile = event.target.files[0];
      this.fileName = this.selectedFile.name;
      this.spinShow = false;
    },

    getUserName() {
      const params = {
        inputValue: this.inputValue,
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
      };
      this.$network.post("/p/cs/getAddressee", params).then((res) => {
        this.userName = res.data;
      });
    },

    checkFile() {
      let file = this.selectedFile;
      if (file == null) {
      	this.$Message.error("请正确选择文件！");
      	return;
      }
      // 文件大于 10MB
      if (file.size > 10485760) {
        this.$Message.error("选择的文件过大(大于10M)，请减少多余内容后再上传！");
        return;
      }
      return true;
    },

    uploadFile() {
      this.spinShow = true;
      if (this.checkFile() != true) {
        this.spinShow = false;
        return;
      }
      
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('path', '/sendEmail/attachments');
 
      axios.post('/p/cs/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        this.spinShow = false;
        let resData = res.data || {};
        if (resData.code == 0) {
          this.fileUrl = resData.data.url;    
          this.$Modal.fcSuccess({
              title: '成功',
              content: resData.message
          });
        } else {
          this.$Modal.fcError({
            title: '失败',
            content: resData.message
          });
        }
      }).catch(error => {
        this.spinShow = false;
        this.$Modal.fcError({
            title: '异常',
            content: error
          });
        console.error(error);
      });
    },

    save() {
      if (!this.inputValue.trim()) {
        const data = {
          mask: true,
          title: "警告",
          content: "请输入原因",
        };
        this.$Modal.fcWarning(data);
        return;
      }
      const params = {
        fileName: this.fileName,
        fileUrl: this.fileUrl,
        inputValue: this.inputValue,
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
        user: this.$store.state.global.userInfo,
      };
      // return;
      this.$network.post("/p/cs/sendEmail", params).then((res) => {
        if (res.data.data.code == 0) {
          this.$Modal.fcSuccess({
            title: "成功",
            content: "邮件发送成功",
          });
          this.$emit("closeActionDialog", true); // 关闭弹框
          // this.$store.commit("global/tabCloseAppoint", {
          //   tableName: this.instanceRouteQuery.tableName, //(主表表名),
          //   routeFullPath: this.instanceRoute, //（路由path）
          // });
        } else {
          this.$Modal.fcError({
            title: "失败",
            content: res.data.data.message,
          });
          this.$emit("closeActionDialog", true); // 关闭弹框
        }
      });
    }, // 确定
    cancel() {
      this.$emit("closeActionDialog", false); // 关闭弹框
    }, // 取消
  },
};
</script>

<style lang="less">
.send-email-box {
  .input_box {
    display: flex;
    flex-direction: row;
    .lable {
      padding-top: 12px;
      padding-right: 6px;
      color: red;
    }
  }
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>